import React from 'react';
import { motion } from 'framer-motion';
import { AwardIcon, CheckIcon, XIcon } from 'lucide-react';
import { productShortName, systemNegatives, totalBonuses, totalVolumes } from '../data/offer';
export function SystemSection() {
  return <section className="bg-green-900 py-16 sm:py-20" aria-labelledby="system-title" data-id="element-250" data-mp="3bh233qpffq8m">
      <div className="mx-auto max-w-4xl px-4 text-center" data-id="element-251" data-mp="36j0mrdjdy50u">
        <span className="inline-flex items-center gap-2 rounded-full bg-amber-500 px-4 py-2 text-xs font-extrabold uppercase tracking-[.12em] text-green-950" data-id="element-252" data-mp="31l8taf33eauj">
          <AwardIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-253" data-mp="2wrw5u8a5ga3d" /> The most comprehensive Drilling &amp; Well Engineering
          teaching system in the world
        </span>
        <h2 id="system-title" className="mx-auto mt-5 max-w-3xl text-balance text-3xl font-extrabold text-stone-50 sm:text-4xl" data-id="element-254" data-mp="2nuvm4ey0z069">
          {productShortName}
        </h2>
        <p className="mt-3 font-semibold text-green-100" data-id="element-255" data-mp="2duuxcdhdzruo">
          {totalVolumes} volumes · {totalBonuses} exclusive bonuses · Everything you need to teach drilling and well engineering with
          confidence.
        </p>

        <ul className="mx-auto mt-10 grid max-w-3xl gap-3 text-left sm:grid-cols-3" data-id="element-256" data-mp="18rhjyfidp4ng">
          {systemNegatives.map(item => <motion.li key={item} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.28,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex gap-3 rounded-lg border border-stone-50/10 bg-green-950/50 p-4 text-sm font-semibold text-green-100" data-id="element-257" data-mp="tz7b3enb3qhi">
              <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-red-300" aria-hidden="true" data-id="element-258" data-mp="1ctw20xe840do" />
              {item}
            </motion.li>)}
        </ul>

        <p className="mx-auto mt-8 flex max-w-3xl items-start gap-3 rounded-xl bg-stone-50 p-6 text-left text-lg font-bold leading-relaxed text-green-950 shadow-lg shadow-black/20" data-id="element-259" data-mp="1blamf9dl1yv">
          <CheckIcon className="mt-1 h-6 w-6 shrink-0 text-green-700" aria-hidden="true" data-id="element-260" data-mp="28yedjmo8trym" />
          It's a complete system so you can enter the classroom with confidence and deliver lessons that truly teach how
          drilling and well engineering works, why well integrity matters, and how drilling engineering contributes to
          safe, efficient well operations while maintaining ethical and safety responsibility.
        </p>
      </div>
    </section>;
}